import React, { useState, useEffect } from 'react';
//Router
import { Link } from 'react-router-dom';
//ANTD
import { Empty, Spin, Checkbox, Button } from 'antd';
//COMPONENTS
import TourItem from '../components/tourItem';

import { FormattedMessage, useIntl } from "react-intl";

//IMAGE
import create_tour from 'static/img/ts_menu_rideplan.png';
import EmptyTabList, { ListWithoutUser } from './emptyTabList';
import TransferButton from './transferButton';
import { TRASFER_GPS_TABS } from '../../../../constants/transfer.constants';
import { MultiDayTourItem } from '../components/multiDayTourItem';

const options = (data, props) => {
    let options = [];
    data.map(item => {
        if (item.multiDay === true) {
            options.push(<MultiDayTourItem item={item} checkedList={props.friendCheckedList} setCheckedList={props.setFriendCheckedList} key={item.id} />)
        } else {
            options.push(
                <Checkbox value={item.id} key={item.id}>
                    <TourItem item={item} TourBasketDataDelete={props.TourBasketDataDelete} key={item.id} isLinkEnabled />
                </Checkbox>
            )
        }
    });
    return options;
}

const FriendsTab = props => {
    const {
        setFriendCheckedList,
        friendTourList,
        loadingFriendsTourList,
        friendCheckedList,
        isLogin,
        loginModalOpen,
    } = props;

    return (
        <React.Fragment>
            <div className="listDownlaodTour" style={props.getListStyleIE(friendCheckedList.length)}>
                {loadingFriendsTourList ?
                    <div style={{ marginTop: '30px' }}>
                        <Spin />
                    </div>
                    :
                    friendTourList.length === 0 ?
                        (isLogin() ? <EmptyTabList /> : <ListWithoutUser showLogin={loginModalOpen} />)
                        :
                        <Checkbox.Group value={friendCheckedList} onChange={setFriendCheckedList}>
                            {options(friendTourList, props)}
                        </Checkbox.Group>
                }
            </div>
            <TransferButton
                hanleClick={() => props.transferRoutes(friendTourList, friendCheckedList, TRASFER_GPS_TABS.FRIEND_TOURS)}
                isDisabled={friendCheckedList.length === 0}
                isDetectedTT={props.isDetectedTT}
            />
        </React.Fragment>
    )

}


export default FriendsTab;